import { render, staticRenderFns } from "./altavenda_index.vue?vue&type=template&id=67a1085a&scoped=true&"
import script from "./altavenda_index.vue?vue&type=script&lang=js&"
export * from "./altavenda_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a1085a",
  null
  
)

export default component.exports